import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../styles/Navbar.css";
import industriesImage from "../images/industries.png";
import logo from "../assets/logo.png";
import {
  // =========================
  // MAIN NAVIGATION
  // =========================

  FaHome as House,
  FaTools as Services,
  FaIndustry as Industry,
  FaFolderOpen as CaseStudies,
  FaUserTie as Career,
  FaInfoCircle as About,
  FaSignInAlt as Login,
  FaPhone as Contact,

  // =========================
  // SERVICES
  // =========================

  FaLaptopCode as ITServices,
  FaRobot as AIWork,
  FaCloud as Cloud,
  FaShieldAlt as CyberSecurity,
  FaBullhorn as DigitalMarketing,
  FaUsersCog as BPO,
  FaUserClock as HR,
  FaUsers as ManPowering,
  FaGraduationCap as Internship,
  FaCalculator as Financial,

  // =========================
  // INDUSTRIES
  // =========================

  FaNetworkWired as Technology,
  FaGraduationCap as Education,
  FaUniversity as Government,
  FaHotel as Hospitality,
  FaHeartbeat as Healthcare,
  FaBriefcase as ProfessionalServices,
  FaShoppingCart as Ecommerce
} from "react-icons/fa";
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Controls whether the navbar is currently visible.
  const [navbarVisible, setNavbarVisible] = useState(true);

  // Hide the navbar shortly after scrolling stops.
  const navbarHideTimer = useRef(null);
  const navbarHovered = useRef(false);

  useEffect(() => {
    const showNavbarWhileScrolling = () => {
      // Always keep the navbar visible at the very top of the page.
      if (window.scrollY <= 10) {
        setNavbarVisible(true);

        if (navbarHideTimer.current) {
          clearTimeout(navbarHideTimer.current);
          navbarHideTimer.current = null;
        }
        return;
      }

      // Show immediately whenever the user scrolls.
      setNavbarVisible(true);

      if (navbarHideTimer.current) {
        clearTimeout(navbarHideTimer.current);
      }

      // Hide only after scrolling stops, unless the mouse is over
      // the navbar or the mobile menu is open.
      navbarHideTimer.current = setTimeout(() => {
        if (!menuOpen && !navbarHovered.current && window.scrollY > 10) {
          setNavbarVisible(false);
        }
      }, 1800);
    };

    window.addEventListener("scroll", showNavbarWhileScrolling, { passive: true });

    return () => {
      window.removeEventListener("scroll", showNavbarWhileScrolling);

      if (navbarHideTimer.current) {
        clearTimeout(navbarHideTimer.current);
      }
    };
  }, [menuOpen]);

  // If the mobile menu is opened, always keep the navbar visible.
  useEffect(() => {
    if (menuOpen) {
      setNavbarVisible(true);

      if (navbarHideTimer.current) {
        clearTimeout(navbarHideTimer.current);
        navbarHideTimer.current = null;
      }
    }
  }, [menuOpen]);

  const [servicesOpen, setServicesOpen] = useState(false);
  const [desktopServicesOpen, SetDesktopServicesOpen] = useState(false);
  const servicesCloseTimer = useRef(null);
  
  const clearServicesCloseTimer = () => {
    if (servicesCloseTimer.current){
      clearTimeout(servicesCloseTimer.current);
      servicesCloseTimer.current = null;
    }
  };

  const openDesktopServices = () =>{
    clearServicesCloseTimer();
    SetDesktopServicesOpen(true);
  };

  const scheduleDesktopServicesClose = () => {
    clearServicesCloseTimer();
    servicesCloseTimer.current = setTimeout(()=>{
      SetDesktopServicesOpen(false);
      servicesCloseTimer.current=null;
    },500);
  };

  const [industriesOpen, setIndustriesOpen] = useState(false);
  const [desktopIndustriesOpen, setDesktopIndustriesOpen] = useState(false);
  const industriesCloseTimer = useRef(null);

  const clearIndustriesCloseTimer = () => {
    if (industriesCloseTimer.current) {
      clearTimeout(industriesCloseTimer.current);
      industriesCloseTimer.current = null;
    }
  };

  const openDesktopIndustries = () => {
    clearIndustriesCloseTimer();
    setDesktopIndustriesOpen(true);
  };

  const scheduleDesktopIndustriesClose = () => {
    clearIndustriesCloseTimer();
    industriesCloseTimer.current = setTimeout(() => {
      setDesktopIndustriesOpen(false);
      industriesCloseTimer.current = null;
    }, 500);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setServicesOpen(false);
    clearServicesCloseTimer();
    SetDesktopServicesOpen(false);
    setIndustriesOpen(false);
    clearIndustriesCloseTimer();
    setDesktopIndustriesOpen(false);
  };
  const toggleServices = ()=>{
    setServicesOpen((prev) => !prev);
  };

  const toggleIndustries = () => {
    setIndustriesOpen((prev) => !prev);
  };

  return (
    <>
      <nav
        className={`navbar ${navbarVisible ? "navbar-visible" : "navbar-hidden"}`}
        onMouseEnter={() => {
          navbarHovered.current = true;
          setNavbarVisible(true);

          if (navbarHideTimer.current) {
            clearTimeout(navbarHideTimer.current);
            navbarHideTimer.current = null;
          }
        }}
        onMouseLeave={() => {
          navbarHovered.current = false;

          // If we are not at the top and the menu is closed,
          // allow the navbar to hide again after 1.8 seconds.
          if (!menuOpen && window.scrollY > 10) {
            if (navbarHideTimer.current) {
              clearTimeout(navbarHideTimer.current);
            }

            navbarHideTimer.current = setTimeout(() => {
              if (!navbarHovered.current && !menuOpen && window.scrollY > 10) {
                setNavbarVisible(false);
              }
            }, 1800);
          }
        }}
      >

        {/* LOGO */}
        <Link to="/" className="logo-section" onClick={closeMenu}>
          <img
            src={logo}
            alt="Techlynx Innovations logo"
            className="company-logo"
          />

          <div className="company-name">
            <h2>Techlynx</h2>
            <span>Innovations Pvt Ltd</span>
          </div>
        </Link>

        {/* DESKTOP NAVIGATION */}
        <div className="navbar-actions">
        <ul className="nav-links">

          <li>
            <NavLink
              to="/"
              end
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              <House id="nav-icon" size={16} />
              <span> Home</span>
            </NavLink>
          </li>

          
          {/*}
          <li>
            <Link to="/services"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Services
            </Link>
          </li>*/}
          <li
            className={`dropdown ${desktopServicesOpen ? "is-open" : ""}`}
            onMouseEnter={openDesktopServices}
            onMouseLeave={scheduleDesktopServicesClose}
            onFocus={openDesktopServices}
            onBlur={scheduleDesktopServicesClose}
          >

            <div className="industries-navigation">
              <NavLink className="industries-link" to="/services"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
                <Services size={16} />
                Services
              </NavLink>
            </div>

            <div className="industries-dropdown">

                {/* COLUMN 1 */}
                <div className="industry-column">
                  <NavLink
                    to="/services/it-services"
onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}                  >
                <ITServices size={16}/>
                   IT Services and Solutions                             {/*pending after file creation*/}

                  </NavLink>

                  <NavLink
                    to="/services/ai-work-film"
onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}                  >
                <AIWork size={16}/>
                    AI Work stations & AI Film making 
                  </NavLink>

                  <NavLink
                    to="/services/cloud-platforms"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    < Cloud size={16}/>
                    Cloud Platforms 
                  </NavLink>


                  <NavLink
                    to="/services/cyber-security"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <CyberSecurity size={16}/>
                    Cyber Security 
                  </NavLink>

                  <NavLink
                    to="/services/digital-marketing"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <DigitalMarketing size={16}/>
                    Digital Marketing 
                  </NavLink>

                </div>
                

                {/* COLUMN 3 */}
                <div className="industry-column">

                  <NavLink
                    to="/services/bpo"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <BPO size={16}/>
                    BPO Services
                  </NavLink>

                  <NavLink
                    to="/services/hr-payroll"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <HR size={16}/>
                    HR and Payroll Services
                  </NavLink>

                  <NavLink
                    to="/services/manpowering"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <ManPowering size={16}/>
                    Man Powering 
                  </NavLink>

                  <NavLink
                    to="/services/internship-training"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <Internship size={16}/>
                    Internship and Training
                  </NavLink>

                  <NavLink
                    to="/services/ca-financial-services"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <Financial size={16}/>
                    CA and Taxation 
                  </NavLink>

                </div>
                

            </div>

          </li>

          

          

          {/* INDUSTRIES */}
          {/*
          <li
            className={`dropdown ${desktopIndustriesOpen ? "is-open" : ""}`}
            onMouseEnter={openDesktopIndustries}
            onMouseLeave={scheduleDesktopIndustriesClose}
            onFocus={openDesktopIndustries}
            onBlur={scheduleDesktopIndustriesClose}
          >

            <div className="industries-navigation">
              <Link className="industries-link" to="/industries/technology" onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
                <Industry size={16} />
                Industries
              </Link>
            </div>

            <div className="industries-dropdown">

                {/* COLUMN 1 */} {/* 
                <div className="industry-column">

                  <Link
                    to="/industries/technology"
onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}                  >
                <Technology size={16} />
                    Technology 
                  </Link>

                  <Link
                    to="/industries/education"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <Education size={16} />
                    Education 
                  </Link>


                  <Link
                    to="/industries/government"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <Government size={16} />
                    Government Sectors 
                  </Link>

                  <Link
                    to="/industries/hospitality"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <Hospitality size={16} />
                    Hospitality 
                  </Link>

                </div>

                {/* COLUMN 3 */}  {/* 
                <div className="industry-column">

                  <Link
                    to="/industries/healthcare"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <Healthcare size={16} />
                    Healthcare 
                  </Link>

                  <Link
                    to="/industries/professional-services"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <ProfessionalServices size={16} />
                    Professional Services 
                  </Link>

                  <Link
                    to="/industries/ecommerce"
                    onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
                  >
                    <Ecommerce size={16} />
                    E-Commerce 
                  </Link>

                </div>
                

            </div>

          </li>

          <li>
            <Link to="/case-studies" onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
                <CaseStudies id="nav-icon" size={16} />
              Case Studies
            </Link>
          </li> */}

          <li>
            <NavLink to="/career" onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
                <Career id="nav-icon" size={16} />
              Career
            </NavLink>
          </li>
          
          <li>
            <NavLink to="/about"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              <About id="nav-icon" size={16} />
              About Us
            </NavLink>
          </li>
          <li></li>

        </ul>

        {/* DESKTOP ACTIONS */}
        

          <NavLink
            to="/login"
            className={({ isActive }) => `login-btn${isActive ? " active" : ""}`}
            onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
          >
            <Login size={16} />
            Login
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) => `connect-btn${isActive ? " active" : ""}`}
            onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
          >
            <Contact size={16} />
            <h3>Connect With Us</h3>
          </NavLink>

        </div>

        {/* MOBILE HAMBURGER */}
        <button
          type="button"
          className={`menu-toggle ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

      </nav>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>

        <NavLink to="/" end onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
          Home
        </NavLink>

        <NavLink to="/about" onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
          About Us
        </NavLink>
        <NavLink to="/career" onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
          Career
        </NavLink>
       {/*
        <Link to="/services" onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
          Services
        </Link>*/}
        <div className="industries-navigation">
          <NavLink to="/services" className="industries-link" onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
            Services
          </NavLink>
          <button
            type="button"
            className="industries-toggle"
            onClick={toggleServices}
            aria-label="Toggle Services menu"
            aria-expanded={servicesOpen}
          >
            <span>⌄</span>
          </button>
        </div>

        {servicesOpen && (
          <div className="mobile-industries-submenu">

            <NavLink
              to="/services/it-services"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              IT Services
            </NavLink>

            <NavLink
              to="/services/ai-work-film"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
              AI Work Station and AI Film
            </NavLink>

            <NavLink
              to="/services/cloud-platforms"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Cloud Platforms
            </NavLink>

            <NavLink
              to="/services/cyber-security"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Cyber Security
            </NavLink>

            <NavLink
              to="/services/digital-marketing"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Digital Marketing
            </NavLink>

            <NavLink
              to="/services/bpo"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              BPO Services
            </NavLink>

            <NavLink
              to="/services/hr-payroll"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              HR and Payroll services
            </NavLink>

            <NavLink
              to="/services/manpowering"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Man Powering
            </NavLink>

            <NavLink
              to="/services/internship-training"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Internship and Training
            </NavLink>

            <NavLink
              to="/services/ca-financial-services"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              CA and Taxation
            </NavLink>

          </div>
        )}

        {/*<Link to="/case-studies" onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
          Case Studies
        </Link> */}

        
        {/*}
        <div className="industries-navigation">
          <Link to="/industries" className="industries-link" onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
            Industries Insights
          </Link>
          <button
            type="button"
            className="industries-toggle"
            onClick={toggleServices}
            aria-label="Toggle Services menu"
            aria-expanded={servicesOpen}
          >
            <span>⌄</span>
          </button>
        </div>

        {servicesOpen && (
          <div className="mobile-industries-submenu">

            <Link
              to="/industries/technology"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Technology
            </Link>

            <Link
              to="/industries/education"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}>
              Education
            </Link>

            <Link
              to="/industries/government"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Government Sectors
            </Link>

            <Link
              to="/industries/hospitality"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Hospitality
            </Link>

            <Link
              to="/industries/healthcare"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Healthcare
            </Link>

            <Link
              to="/industries/professional-services"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              Professional Services
            </Link>

            <Link
              to="/industries/ecommerce"
              onClick={() => {
                closeMenu();
                window.scrollTo(0, 0);
              }}
            >
              E-Commerce
            </Link>

          </div>
        )}*/}

        <Link
          to="/contact"
          className="mobile-connect-btn"
          onClick={closeMenu}
        >
          Connect With Us
        </Link>

        <Link
          to="/login"
          className="mobile-login-btn"
          onClick={closeMenu}
        >
          Login
        </Link>

      </div>
    </>
  );
};

export default Navbar;